import { CoinsIcon } from '@infl-ts/ui-advocate-icons';
import { Box, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PointsForCompletion = function PointsForCompletion(_ref) {
  var points = _ref.points;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      mb: 2,
      color: function color(t) {
        return t.palette.text.secondary;
      }
    },
    "data-element": "Box",
    "data-component": "PointsForCompletion",
    "data-source-file": "points-for-completion.tsx",
    children: [/*#__PURE__*/_jsx(CoinsIcon, {
      sx: {
        mr: 0.5,
        height: function height(t) {
          return t.typography.h5.fontSize;
        },
        width: function width(t) {
          return t.typography.h5.fontSize;
        }
      },
      "data-element": "CoinsIcon",
      "data-component": "PointsForCompletion",
      "data-source-file": "points-for-completion.tsx"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      "data-element": "Typography",
      "data-source-file": "points-for-completion.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-source-file": "points-for-completion.tsx",
        children: function children(t) {
          return t('{{points}} for completing this stage', {
            points: points
          });
        }
      })
    })]
  });
};

export default PointsForCompletion;